export const HEADER_COPY = "HEADER COPY";
export const BODY_COPY = "BODY COPY";
export const CTA_COPY = "CTA COPY";
export const CTA_LINK = "CTA LINK";
export const IMAGE = "IMAGE FILE NAME";
export const IMAGE_NAME = "IMAGE NAME";
export const COLOUR = "COLOUR";
export const TAGS = "TAGS";

export const URL_SLUG = "url-slug";
export const TITLE = "event-title";
export const BODY_COPY_1 = "body-copy-1";
export const BODY_COPY_2 = "body-copy-2";
export const CARD = "card";
export const CATEGORY_TAGS = "category-tags";
export const CTA_BOOK = "cta-book";
export const DATES = "dates";
export const START_DATE = "start-date";
export const END_DATE = "end-date";



// WEBPACK FOOTER //
// ./src/utils/content-keys.js